import ReactTurnstile from 'react-turnstile'

import { TurnstileTooltip } from '../turnstileTooltip'
import { TURNSTILE_CONFIG } from '../../consts'
import { useTooltipConfig, useTurnstileEvents } from '../../utils/index'
import { getLanguageCode } from '../../../../utils/translation'
import { getTurnstileSitekey } from '../../utils/getTurnstileSitekey'

import { TurnstileWrapper } from './styled'
import './style.css'

/**
 * React Component for Integrating Google's reCAPTCHA Service as a Turnstile Challenge.
 * This component utilizes the `react-turnstile` library to render CAPTCHA challenges, enhancing security
 * and user experience by preventing automated interactions.
 */
export const Turnstile = ({
  style = {}, // Optional prop for styling the turnstile wrapper
  handleTurnstileStatus, // Callback function to handle turnstile status updates
  turnstileStatus, // Current status of the turnstile challenge, including token and methods
}) => {
  const lang = getLanguageCode()
  // Dynamically obtains the appropriate site key for the turnstile challenge, adapting to different environments
  const turnstileSiteKey = getTurnstileSitekey()
  // Generates a set of event handlers for interacting with the turnstile challenge, linked to the provided callback function
  const turnstileEvents = useTurnstileEvents(handleTurnstileStatus)
  // Configures tooltip display and content based on the turnstile's current status, enhancing user feedback
  const {
    open,
    statusConfig: { message, ...rest },
  } = useTooltipConfig(turnstileStatus)

  return (
    <TurnstileTooltip
      open={open} // Controls the visibility of the tooltip
      message={message} // Sets the tooltip's message content
      methods={turnstileStatus?.methods || {}} // Passes turnstile methods to the tooltip for interactive elements
      {...rest} // Spreads additional tooltip configuration options
    >
      <TurnstileWrapper style={style}>
        <ReactTurnstile
          {...TURNSTILE_CONFIG} // Spreads default turnstile configuration
          {...turnstileEvents} // Injects dynamically generated event handlers
          language={lang} // Sets the language for the turnstile challenge
          sitekey={turnstileSiteKey} // Specifies the site key for the turnstile challenge
        />
      </TurnstileWrapper>
    </TurnstileTooltip>
  )
}
